module.exports = __webpack_public_path__ + "img/circle.8c2ffa59.svg";